export const APP = {
  SELL: 'sell',
};

export const SEARCH_TERM = 'search.term';
export const SEARCH_EXPANDED_VARIANT = 'expanded';
export const SEARCH_MODAL_VARIANT = 'modal';

export const CMA_DEFAULTS = {
  GEO_ID: 6628,
};
